import { mapGetters } from "vuex";

export const getCatValues = {
  computed: {
    ...mapGetters(["loading", "categoryValue"])
  },
  methods: {
    catValueList(catNameInput) {
      // Safely handle missing data
      if (!this.categoryValue || !this.categoryValue.edges) {
        console.warn('Category data not properly loaded');
        return [];
      }

      return this.categoryValue.edges
        .filter(category => {
          return category && category.node && category.node.category;
        })
        .filter(category => {
          const catName = category.node.category.catName;
// return typeof catName === 'string' && regex.test(catName);  // like match instead of exact          
          return (
            typeof catName === 'string' &&
            catName.toLowerCase() === catNameInput.toLowerCase()
          );
        });
    },

    catValueListArray(catNameInput) {
      const result = this.catValueList(catNameInput)
        .map(item => item && item.node && item.node.valName)
        .filter(val => typeof val === 'string');

      return result.length ? [...new Set(result)] : [];
    }

  }
};